import type { SessionEmployeeRecord } from '../../auth/application/sessionEmployeeTypes';

export type EmployeeAccessStamp = {
  employeeId: string;
  isActive: boolean;
  permissionsUpdatedAt: string | null;
};

/** Pure: decide si hay que forzar re-bootstrap / re-resolve de sesión empleado. */
export function shouldRefreshEmployeePermissions(args: {
  previous: Pick<SessionEmployeeRecord, 'isEmployee' | 'isActive' | 'permissionsUpdatedAt'> | null;
  next: EmployeeAccessStamp | null;
}): boolean {
  const { previous, next } = args;
  if (!next) return false;

  if (next.isActive === false) {
    if (!previous) return true;
    if (previous.isEmployee !== true) return true;
    if (previous.isActive !== false) return true;
  }

  const prevStamp = previous?.permissionsUpdatedAt ?? null;
  const nextStamp = next.permissionsUpdatedAt ?? null;
  if (nextStamp && nextStamp !== prevStamp) return true;

  if (previous?.isEmployee === true && previous.isActive === false && next.isActive === true) {
    return true;
  }

  return false;
}
